import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-create-tote',
  templateUrl: './create-tote.component.html',
  styleUrls: ['./create-tote.component.css']
})
export class CreateToteComponent implements OnInit {

  toteName: string;
  toteType: string;
  toteNameError: string;
  toteTypeError: string;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private g: Globals) {
    this.g.page = "Create Tote"
  }

  ngOnInit() {
  }
  typeToteName() {
    this.toteNameError = "";
    if (this.toteName == '' || this.toteName === null || this.toteName === undefined || this.toteName === 'undefined') {
      this.toteNameError = 'Please enter tote name';
    }
  }
  typeToteType() {
    this.toteTypeError = "";
    if (this.toteType == '' || this.toteType === null || this.toteType === undefined || this.toteType === 'undefined') {
      this.toteTypeError = 'Please enter tote type';
    }
  }
  submitTote() {
    this.g.loaderDisplay = "display";
    this.toteNameError = "";
    this.toteTypeError = "";

    if (this.toteName == '' || this.toteName === null || this.toteName === undefined || this.toteName === 'undefined') {
      this.toteNameError = 'Please enter tote name';
    }
    if (this.toteType == '' || this.toteType === null || this.toteType === undefined || this.toteType === 'undefined') {
      this.toteTypeError = 'Please enter tote type';
    }

    if (this.toteNameError != "" || this.toteTypeError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createTotes', {

      "toteName": this.toteName,
      "toteType": this.toteType,
      "status": 'ACTIVE',
      "organizationId": 1
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Tote', 'Created Successfully');
          this.router.navigate(['/admin/toteList']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        });
  }

}
